var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragAndDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.4,10c0,1.6,0,3.1,0,4.8c0.3,0,0.5,0,0.7,0c3.6,0,7.3,0,10.9,0c1.8,0,2.7,0.9,2.7,2.7c0,2.9,0,5.7,0,8.6 c0,0.2,0,0.4,0,0.6c-1.6,0-3.1,0-4.7,0c0-2.3,0-4.7,0-7.1c-8,0-15.9,0-23.8,0c0,7.9,0,15.8,0,23.8c3.2,0,6.3,0,9.5,0 c0,1.6,0,3.1,0,4.7c-0.2,0-0.4,0-0.7,0c-3.6,0-7.2,0-10.8,0c-1.7,0-2.8-1.1-2.8-2.8c0.1-3.6,0-7.2,0-10.8c0-0.2,0-0.4,0-0.7 c-1.6,0-3.1,0-4.7,0c0-1.6,0-3.2,0-4.8c1.6,0,3.1,0,4.7,0c0-0.3,0-0.5,0-0.7c0-3.6,0-7.3,0-10.9c0-1.8,0.9-2.7,2.7-2.7 c3.6,0,7.3,0,10.9,0c0.2,0,0.4,0,0.7,0c0-1.6,0-3.2,0-4.8C30.2,10,31.7,10,33.4,10z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,49.6c-1.7-2.9-3.4-5.8-5.1-8.8c-1.8,1.7-3.5,3.4-5.3,5.1c0-6.5,0-12.8,0-19.2c5.5,3.2,11,6.4,16.6,9.7 c-2.4,0.7-4.7,1.4-7.1,2c1.7,2.9,3.4,5.8,5.1,8.8C46.6,48,45.3,48.7,43.8,49.6z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0.5c1.6,0,3.1,0,4.7,0c0,1.6,0,3.1,0,4.7c-1.6,0-3.1,0-4.7,0C9.5,3.6,9.5,2.1,9.5,0.5z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,5.1c-1.6,0-3.1,0-4.7,0c0-1.6,0-3.1,0-4.7c1.6,0,3.1,0,4.7,0C23.8,2,23.8,3.5,23.8,5.1z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.7c0-1.6,0-3.1,0-4.7c1.6,0,3.1,0,4.7,0c0,1.6,0,3.1,0,4.7C3.1,14.7,1.6,14.7,0,14.7z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24.2c0-1.6,0-3.1,0-4.7c1.6,0,3.1,0,4.7,0c0,1.6,0,3.1,0,4.7C3.1,24.2,1.6,24.2,0,24.2z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.4c1.6,0,3.1,0,4.7,0c0,1.6,0,3.1,0,4.7c-1.5,0-3.1,0-4.7,0C0,3.6,0,2,0,0.4z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,0.5c0,1.6,0,3.1,0,4.7c-1.6,0-3.1,0-4.7,0c0-1.5,0-3.1,0-4.7C30.2,0.5,31.7,0.5,33.3,0.5z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,33.8c-1.6,0-3.1,0-4.7,0c0-1.6,0-3.1,0-4.7c1.5,0,3.1,0,4.7,0C4.7,30.6,4.7,32.2,4.7,33.8z",
    fill: "#9D9D9D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag-and-drop.5ad86cf578acfe359cdf0aa28f66b9f8.svg";
export { ForwardRef as ReactComponent };